import { render, staticRenderFns } from "./set_and_create_form.vue?vue&type=template&id=3a3b43a4&lang=pug&"
import script from "./set_and_create_form.vue?vue&type=script&lang=js&"
export * from "./set_and_create_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports